// extracted by mini-css-extract-plugin
module.exports = {"container":"SimilarProductsSection_container__pdstt"};